import script from "./PropertyCardSubLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyCardSubLocation.vue?vue&type=script&setup=true&lang=js"

import "./PropertyCardSubLocation.vue?vue&type=style&index=0&id=208f43e7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208f43e7"]])

export default __exports__